












































































import BrowserMoreImg from '@/components/image/BrowserMoreImg.vue'
import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import {Component, Mixins, Prop} from 'vue-property-decorator'

@Component({
  components: {BrowserMoreImg},
})
export default class AddToHomeScreenBanner extends Mixins(Translation, Assets) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) isKakaoBrowser: boolean
  @Prop({default: false, type: Boolean}) isInAppBrowser: boolean
  @Prop({default: false, type: Boolean}) isSafariBrowser: boolean

  get visibleSafariBanner(): boolean {
    return !(this.isKakaoBrowser || this.isInAppBrowser) && this.isSafariBrowser
  }
}
